import React from "react";
import PropTypes from "prop-types";

import { useConnectionType } from "scenes/Hubly/components/HubModals/components/ConnectCRMModal/hooks";

import {
  FirstCrmConnectionMessage,
  RequiredCrmConnectionMessage,
  ResetCrmConnectionMessage,
} from "./components";

function DisclaimerMessage({ onAcknowledge, ...props }) {
  const { isCrmReset, isRequiredCrmConnection } = useConnectionType();

  if (isCrmReset) return <ResetCrmConnectionMessage {...props} />;

  if (isRequiredCrmConnection)
    return <RequiredCrmConnectionMessage {...props} />;

  return <FirstCrmConnectionMessage {...props} onAcknowledge={onAcknowledge} />;
}

DisclaimerMessage.propTypes = { onAcknowledge: PropTypes.func };

DisclaimerMessage.defaultProps = { onAcknowledge: () => {} };

export default DisclaimerMessage;
